import { WsRadioObj, WsSelectObj, WsToggleObject } from 'wisestep-base';

export const languages = [
  'Afrikaans',
  'Albanian',
  'Amharic',
  'Arabic',
  'Armenian',
  'Azerbaijani',
  'Basque',
  'Belarusian',
  'Bengali',
  'Bosnian',
  'Bulgarian',
  'Catalan',
  'Cebuano',
  'Chichewa',
  'Chinese (Simplified and Traditional)',
  'Corsican',
  'Croatian',
  'Czech',
  'Danish',
  'Dutch',
  'English',
  'Esperanto',
  'Estonian',
  'Filipino',
  'Finnish',
  'French',
  'Frisian',
  'Galician',
  'Georgian',
  'German',
  'Greek',
  'Gujarati',
  'Haitian Creole',
  'Hausa',
  'Hawaiian',
  'Hebrew',
  'Hindi',
  'Hmong',
  'Hungarian',
  'Icelandic',
  'Igbo',
  'Indonesian',
  'Irish',
  'Italian',
  'Japanese',
  'Javanese',
  'Kannada',
  'Kazakh',
  'Khmer',
  'Korean',
  'Kurdish (Kurmanji)',
  'Kyrgyz',
  'Lao',
  'Latin',
  'Latvian',
  'Lithuanian',
  'Luxembourgish',
  'Macedonian',
  'Malagasy',
  'Malay',
  'Malayalam',
  'Maltese',
  'Maori',
  'Marathi',
  'Mongolian',
  'Myanmar (Burmese)',
  'Nepali',
  'Norwegian',
  'Pashto',
  'Persian',
  'Polish',
  'Portuguese',
  'Punjabi',
  'Romanian',
  'Russian',
  'Samoan',
  'Scots Gaelic',
  'Serbian',
  'Sesotho',
  'Shona',
  'Sindhi',
  'Sinhala',
  'Slovak',
  'Slovenian',
  'Somali',
  'Spanish',
  'Sundanese',
  'Swahili',
  'Swedish',
  'Tajik',
  'Tamil',
  'Telugu',
  'Thai',
  'Turkish',
  'Ukrainian',
  'Urdu',
  'Uzbek',
  'Vietnamese',
  'Welsh',
  'Xhosa',
  'Yiddish',
  'Yoruba',
  'Zulu',
];

export const contactPreferences = {
  Phone: 'Phone',
  Email: 'Email',
  Both: 'Both',
};

export const workAuthorization = {
  Citizen: 'Citizen',
  VisaIndependent: 'Visa Independent',
  VisaDependent: 'Visa Dependent',
  Others: 'Others',
};

export const jobPreferences = {
  Contract: 'Contract',
  Permanent: 'Permanent',
};

export const sortOptions: WsSelectObj[] = [
  {
    label: 'Relevance: Most',
    value: '_score,desc',
  },
  {
    label: 'New To Old',
    value: 'createdOn,desc',
  },
  {
    label: 'Old To New',
    value: 'createdOn,asc',
  },
];
export const toggleArray: WsToggleObject[] = [
  {
    label: 'Preferred',
    value: 'talentpool',
  },
  {
    label: 'Current',
    value: 'pipeline',
  },
];
export const recencyList: WsRadioObj[] = [
  {
    value: '0,90',
    label: '0-3 Months',
  },
  {
    value: '90,180',
    label: '3-6 Months',
  },
  {
    value: '180,360',
    label: '6-12 Months',
  },
  {
    value: '360,9999',
    label: '> 12 Months',
  },
];
export const locations: WsRadioObj[] = [
  {
    value: 'city',
    label: 'Same City as Job',
  },
  {
    value: 'state',
    label: 'Same State as Job',
  },
  {
    value: 'country',
    label: 'Same Country as Job',
  },
  {
    value: 'Others',
    label: 'Others',
  },
];

export const aiContactPreferences: WsRadioObj[] = [
  {
    value: 'Yes',
    label: 'Yes',
  },
  {
    value: 'No',
    label: 'No',
  },
  {
    value: 'All',
    label: 'All',
  },
];
export const candidateStatus = {
  Uploaded: 'Uploaded',
  Applied: 'Applied',
  Mapped: 'Mapped',
  Submitted: 'Submitted',
};

export const defaultResetFilters = {
  createBWDates: {
    toDateName: '',
    fromDateName: '',
  },
  SalaryRangeProps: {
    currency: '',
    unitTime: '',
    max: 0,
    min: 0,
  },
  NoticePeriod: {
    min: 0,
    max: 0,
  },
};

export const searchOptions: WsSelectObj[] = [
  {
    label: 'Name',
    value: 'Name',
  },
  {
    label: 'Email',
    value: 'Email',
  },
  {
    label: 'Phone No',
    value: 'Phone No',
  },
];
